import { ScenariosPages } from "./UI/ContentBlocks";
import { WebsiteContentObject } from "./WebsiteContentObject";
import LocomotiveScroll from "locomotive-scroll";

const Safety = () => {
  if (window.screen.width >= 767) {
    (function () {
      new LocomotiveScroll();
    })();
  }
  const root = WebsiteContentObject.publicSafety;
  return <ScenariosPages banner={root.banner} content={root.content} />;
};

export default Safety;
